import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DynamicFormComponent } from '@shared/modules/dynamic-forms/components/dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-common-editor',
  templateUrl: './common-editor.component.html',
  styleUrls: ['./common-editor.component.scss']
})
export class CommonEditorComponent implements OnInit {

  @Input()
  public submit: () => any;

  @ViewChild(DynamicFormComponent, { static: true })
  private dynamicForm: DynamicFormComponent;

  constructor(public dialogRef: MatDialogRef<CommonEditorComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  public get form(): FormGroup {
    return this.dynamicForm.form;
  }

  public formSubmit() {
    this.submit();
  }

}
